import { useMemo, useCallback } from 'react';
import { toUSD, toNumber } from '../utils/currencyConverter';

export const useDDPCalculation = (productPrice, shipmentData) => {
  return useMemo(() => {
    if (!shipmentData || !productPrice) return null;

    const { costs, grossWeight, netWeight } = shipmentData;

    // Веса
    const grossWeightNum = toNumber(grossWeight);
    const netWeightNum = toNumber(netWeight);

    if (grossWeightNum <= 0 || netWeightNum <= 0) return null;

    const tons = grossWeightNum / 1000;

    // Цена продукта в USD
    const productPriceUSD = toUSD(productPrice);
    const exwTotal = productPriceUSD * tons;

    // Все расходы в USD
    const originInlandFreight = toUSD(costs?.originInlandFreight);
    const exportCustomsClearance = toUSD(costs?.exportCustomsClearance);
    const seaAirFreight = toUSD(costs?.seaAirFreight);
    const freightSurcharges = toUSD(costs?.freightSurcharges);
    const cargoInsurance = toUSD(costs?.cargoInsurance);

    const cifValue = exwTotal
      + originInlandFreight
      + exportCustomsClearance
      + seaAirFreight
      + freightSurcharges
      + cargoInsurance;

    // Проценты
    const customsDutyPercent = toNumber(costs?.customsDutyPercent);
    const vatPercent = toNumber(costs?.vatPercent);

    const customsDuty = cifValue * (customsDutyPercent / 100);
    const vat = (cifValue + customsDuty) * (vatPercent / 100);

    // Остальные расходы
    const customsBrokerage = toUSD(costs?.customsBrokerage);
    const portTerminalHandling = toUSD(costs?.portTerminalHandling);
    const inlandFreightDestination = toUSD(costs?.inlandFreightDestination);
    const bankLCCharges = toUSD(costs?.bankLCCharges);
    const otherCharges = toUSD(costs?.otherCharges);

    const totalDDP = cifValue
      + customsDuty
      + vat
      + customsBrokerage
      + portTerminalHandling
      + inlandFreightDestination
      + bankLCCharges
      + otherCharges;

    return {
      totalDDP,
      perGrossTon: totalDDP / (grossWeightNum / 1000),
      perNetTon: totalDDP / (netWeightNum / 1000),
      perGrossKg: totalDDP / grossWeightNum,
      perNetKg: totalDDP / netWeightNum,
      cifValue,
      customsDuty,
      vat,
      // Дополнительные данные для отладки
      breakdown: {
        exwTotal,
        originInlandFreight,
        exportCustomsClearance,
        seaAirFreight,
        freightSurcharges,
        cargoInsurance,
        customsBrokerage,
        portTerminalHandling,
        inlandFreightDestination,
        bankLCCharges,
        otherCharges,
        customsDuty,
        vat
      }
    };
  }, [productPrice, shipmentData]);
};